import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store";
import { SessionStorage } from "@/store/session-storage";
import { SearchResponse, SearchItem } from "@/api/user/response";
import { SearchRequest } from "@/api/user/request";
import * as UserAPI from "@/api/user";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "user/search";

/**
 * ユーザ一覧のデコレーター
 */
export class ListItem {
  constructor(private _item: SearchItem) {}
  /** 元のItem */
  get rawItem() {
    return this._item;
  }
  /** 店舗ID */
  get shopId() {
    return this._item.shopId;
  }
  /** 店舗名 */
  get shopName() {
    return this._item.shopName;
  }
  /** ユーザーID */
  get userId() {
    return this._item.userId;
  }
  /** ユーザー名 */
  get userName() {
    return this._item.userName;
  }
  /** 誕生日 */
  get birthday() {
    return ListItem.formatHyphenToSlash(this._item.birthday);
  }
  /** 性別 */
  get gender() {
    switch (this._item.gender) {
      case 1:
        return "男性";
      case 2:
        return "女性";
      default:
        return "不明";
    }
  }
  /** 追加・編集権限の有無 */
  get writeFlg() {
    return this._item.writeFlg;
  }
  /** 削除権限の有無 */
  get deleteFlg() {
    return this._item.deleteFlg;
  }
  private static formatHyphenToSlash(orig: string | null) {
    if (orig == null) {
      return "";
    }
    return orig.replace(/-/g, "/");
  }
}

/**
 * ユーザー一覧・検索API（/search-user）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Search extends VuexModule {
  // state
  searchRequest: SearchRequest = {} as SearchRequest;
  searchResponse: SearchResponse = {} as SearchResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.searchResponse);
  }

  get getMessage() {
    return this.searchResponse.message;
  }

  get getItems() {
    if (this.searchResponse.results) {
      return (this.searchResponse.results.items || []).map(
        i => new ListItem(i)
      );
    } else {
      return [];
    }
  }

  get getTotalCount() {
    if (this.searchResponse.results) {
      return this.searchResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getSearchRequest() {
    return this.searchRequest;
  }

  // MutationActions
  @MutationAction
  async search(searchRequest: SearchRequest) {
    const searchResponse = await UserAPI.search(searchRequest);
    SessionStorage.setObject(MODULE_NAME, searchRequest);
    return {
      searchRequest,
      searchResponse
    };
  }

  @MutationAction
  async restore(initial = {} as SearchRequest) {
    const searchRequest = SessionStorage.getObject(
      MODULE_NAME,
      initial
    ) as SearchRequest;
    return {
      searchRequest
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      searchResponse: {} as SearchResponse
    };
  }
}

export default getModule(Search);
